// extracted by mini-css-extract-plugin
export default {"wrapper":"IntelliSortContainer__wrapper___n3WCJ","container":"IntelliSortContainer__container___kyavK","tableContainer":"IntelliSortContainer__tableContainer___VlgiL"};